// extracted by mini-css-extract-plugin
export default {"rooms":"RoomItems_rooms__zoRJM","notFound":"RoomItems_notFound__KlL4U"};